import React from "react"
import { EWsrvTransform, IAgent } from "../../lib";
import { ILinkFunc } from "../../lib/util";
import { Button } from "../Button";
import { WsrvImage } from "../Media";
import Heading from "./Heading";

export enum EContentLayout {
    imageLeft = "imageLeft",
    imageRight = "imageRight",
}

export interface ITwoColumnAgentBladeProps {
    className?: string;
    title?: string;
    titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
    titleClassName?: string;
    columnsWrapperClass?: string;
    partnerInformation: IAgent;
    agentNameClassName?: string;
    agentLocationClassName?: string
    layout?: EContentLayout;
    linkFunc?: ILinkFunc;
    link?: { label?: string; url?: string };
    buttonClassName?: string;
    isImageHeadshot?: boolean;
}

export const TwoColumnAgentBlade: React.FC<ITwoColumnAgentBladeProps> = ({
    className = "",
    linkFunc,
    title,
    titleClassName = "",
    titleHeadingLevel = "h1",
    columnsWrapperClass = "",
    partnerInformation,
    agentNameClassName = "",
    agentLocationClassName = "",
    layout = EContentLayout.imageLeft,
    link,
    buttonClassName = "",
    isImageHeadshot = false,
}) => {

    const linkf = linkFunc || ((props) => <a {...props} />);

    let leftColClass = "";
    let rightColClass = "";
    switch (layout) {
        case EContentLayout.imageRight:
            leftColClass = "md:order-2";
            rightColClass = "md:order-1";
            break;
        default:
            break;
    }

    const { city, state } = partnerInformation.address ?? {}

    return (
        <section className={`two-column-agent-blade ${className} relative max-w-screen-xl p-5`}>
            {title &&
                <Heading className={`text-center lg:text-left py-4 lg:inline-block lg:w-1/2 ${titleClassName}`} headingLevel={titleHeadingLevel}>{title}</Heading>
            }
            <div className={`relative mx-auto flex flex-row flex-wrap md:flex-nowrap w-full gap-10 lg:gap-14 ${columnsWrapperClass}`}>
                <div className={`${leftColClass} w-full md:w-1/2 h-full`}>
                    {partnerInformation.photos && partnerInformation.photos.length > 0 &&
                        <>
                            <WsrvImage
                                urlParams={{
                                    originURL: partnerInformation.photos[0].url,
                                    preset: isImageHeadshot ? EWsrvTransform.thumb1x1 : EWsrvTransform.cover4x3,
                                }}
                                imgProps={{
                                    className: "w-full object-cover h-full",
                                    wrapperClassName: "h-full"
                                }}
                            />
                            {partnerInformation.expertiseAreas && partnerInformation.expertiseAreas.length > 0 && (
                                <div className="w-full flex flex-col items-center">
                                    <span className="font-medium mb-1">Areas Of Expertise:</span>
                                    <div className="w-full divide-x flex flex-wrap justify-center items-start">
                                        {partnerInformation.expertiseAreas.map((area) => (
                                            <span className="px-2">{area}</span>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                    }
                </div>
                <div className={`${rightColClass} w-full md:w-1/2 h-full`}>
                    {(partnerInformation.fullName || partnerInformation.first || partnerInformation.last) &&
                        <Heading
                            className={`text-center md:text-left my-2 lg:flex lg:items-center lg:before:mr-6 lg:before:inline-block lg:before:content-[''] lg:before:w-28 lg:before:h-px lg:before:bg-neutral-400 ${agentNameClassName}`}
                            headingLevel={"h3"}
                        >
                            {partnerInformation.fullName ?? (partnerInformation.first + " " + partnerInformation.last)}
                        </Heading>}
                    {(city || state) && (
                        <Heading
                            className={`text-center md:text-left mb-5 lg:ml-36 ${agentLocationClassName}`}
                            headingLevel={"p"}
                        >
                            {`${city ?? ""}${city && state ? ", " : ""}${state ?? ""}`}
                        </Heading>
                    )}
                    {partnerInformation.bio && (
                        <div className="text-justify leading-7"
                            dangerouslySetInnerHTML={{ __html: partnerInformation.bio }}
                        ></div>
                    )}
                    {link?.url &&
                        <Button
                            icon={false}
                            linkProps={{
                                href: link.url,
                                className: `w-full md:w-auto normal-case italic font-normal mt-6 ${buttonClassName}`,
                            }}
                            linkFunc={linkf}
                        >
                            {link.label}
                        </Button>
                    }
                </div>
            </div>
        </section>
    )
}

export default TwoColumnAgentBlade

